import { createFileRoute, redirect } from "@tanstack/react-router";

// Blog > Newsletter, retired when the newsletter became the built-in
// integration: its settings moved to Integrations > Newsletter, and the sidebar
// row went with them. Redirects so an old bookmark — and the From-address links
// already sitting in authors' toasts and banners — still lands on the form.
export const Route = createFileRoute("/dashboard/w/$workspaceId/newsletter")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/dashboard/w/$workspaceId/integrations/newsletter",
      params: { workspaceId: params.workspaceId },
    });
  },
});
